import Repository from './Repository'

const action = 'exporter/groups/dispatchers'

export default {
  add(inn, group_id) {
    return Repository.post(action, {
      inn,
      group_id,
    })
  },
  get() {
    return Repository.get(action)
  },
}
